import React from 'react'

import { NotificationEl } from './style'

const Notification = ({ variant, children }) => {
  return <NotificationEl variant={variant}>{children}</NotificationEl>
}

export default Notification
